// extracted by mini-css-extract-plugin
export default {"paper":"config-details-menu_paper__075hF","chip":"config-details-menu_chip__0HSRH","listItemChip":"config-details-menu_listItemChip__JqMwh"};